import { RECIEVE_INVOICE, REQUEST_INVOICE } from '../actions/a.invoice'

import Store from '../store'

const Invoice = (state = Store.Invoice, action) => {
    switch(action.type) {
        case REQUEST_INVOICE:
            return {
                ...state,
                isFetching: true,
            }
        case RECIEVE_INVOICE:
            return {
                ...state,
                item: action.payload.Item,
                imagePath: action.payload.ImagePath,
                message: action.payload.Message,
                userTypes: action.payload.UserTypes,
                isFetching: false,
            }
        default:
            return state
    }
} 

export default Invoice